import { render, staticRenderFns } from "./DuplicateCollectionModal.vue?vue&type=template&id=65b8db3a&lang=pug&"
import script from "./DuplicateCollectionModal.vue?vue&type=script&lang=js&"
export * from "./DuplicateCollectionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports